import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { COMPANY_CONFIG } from '../config/constants';

const WhatsAppFloat = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(true);

  useEffect(() => {
    // Show button after 2 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);

    // Hide tooltip after 10 seconds
    const tooltipTimer = setTimeout(() => {
      setShowTooltip(false);
    }, 10000);

    return () => {
      clearTimeout(timer);
      clearTimeout(tooltipTimer);
    };
  }, []);

  const whatsappUrl = `https://wa.me/${COMPANY_CONFIG.whatsappNumber}?text=${encodeURIComponent(COMPANY_CONFIG.whatsappDefaultMessage)}`;

  if (!isVisible) return null;

  return (
    <>
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl transition-all duration-300 hover:scale-110 group"
        onClick={() => setShowTooltip(false)}
      >
        {/* Tooltip */}
        {showTooltip && (
          <div className="absolute right-full mr-4 bg-white text-gray-800 px-4 py-2 rounded-lg shadow-lg whitespace-nowrap animate-fade-in hidden md:block">
            <div className="font-semibold text-sm">Need Help?</div>
            <div className="text-xs text-gray-600">Chat with us on WhatsApp</div>
            <button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowTooltip(false);
              }}
              className="absolute top-1 right-1 text-gray-400 hover:text-gray-600"
            >
              <X size={14} />
            </button>
            {/* Arrow */}
            <div className="absolute top-1/2 -right-2 transform -translate-y-1/2 w-0 h-0 border-t-8 border-t-transparent border-b-8 border-b-transparent border-l-8 border-l-white"></div>
          </div>
        )}

        {/* WhatsApp Button */}
        <div className="flex items-center gap-2 px-5 py-4">
          <MessageCircle size={28} className="animate-pulse" />
          <span className="font-semibold text-base hidden sm:inline">Chat with us</span>
        </div>

        {/* Pulse animation ring */}
        <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-20"></span>
      </a>
    </>
  );
};

export default WhatsAppFloat;
